var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "88.96 521.8 1155.41 289.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-301.742 -519.877)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-351.15 -473.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-387.778 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-394.484 -460.967)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-446.911 -483.883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-507.423 -475.797)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-542.741 -523.677)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-571.433 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-606.607 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-641.037 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-676.21 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-715.447 -512.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-754.683 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-840.458 -473.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-868.031 -512.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-910.473 -481.312)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-103.032 -525.207)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-206.346 -555.781)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-202.232 -582.234)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-88.114 -484.686)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-118.283 -479.058)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-251.01 -484.686)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-215.9 -481.448)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-169.18 -495.445)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-169.18 -471.416)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-174.004 -490.716)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-195.983 -440.088)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-121.977 -428.253)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-99.095 -479.791)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-120.758 -428.496)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-216.877 -428.253)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-239.76 -479.791)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-218.096 -428.496)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 3.279-1.528 4.931-4.583 4.956h-.075c-3.031 0-4.546-1.653-4.546-4.956v-44.713c0-3.305 1.528-4.956 4.583-4.956 3.08 0 4.621 1.651 4.621 4.956zm10.545-44.713c0-10.235-5.055-15.364-15.166-15.39-10.085 0-15.128 5.129-15.128 15.39V0c0 10.234 5.043 15.352 15.128 15.352C5.49 15.352 10.545 10.234 10.545 0Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 402.322 640.164)",
    clipPath: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-9.043-5.055-13.575-15.166-13.601-10.085 0-15.127 4.534-15.127 13.601v52.091h10.545V0c0-2.907 1.527-4.359 4.582-4.359 3.081 0 4.621 1.452 4.621 4.359v52.091H0Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 468.2 702.167)",
    clipPath: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-9.166h-9.874v-55.445h-10.545v55.445h-9.874V0Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 517.037 632.563)",
    clipPath: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v64.611h10.545V9.203H27.35V0Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 525.98 718.71)",
    clipPath: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.024 26.902L-8.049 0Zm10.657 0 3.428-22.916H3.428L1.378-9.204H-9.39l-2.086-13.712h-10.62l3.429 22.841 7.452 41.77H3.242Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 595.881 688.156)",
    clipPath: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.453 49.781h10.656l-3.427-22.916L7.267-14.83H-7.191l-5.478 33.35-5.439-33.35h-14.457l-7.453 41.77-3.428 22.841h10.619L-25.375 0l7.453 49.781h10.47z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 676.564 698.937)",
    clipPath: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-52.315h4.62c3.056 0 4.583 1.652 4.583 4.956v42.366C9.203-1.664 7.676 0 4.62 0Zm-10.545 10.396H5.701c9.364-.025 14.047-5.155 14.047-15.389v-42.366c0-10.209-4.905-15.327-14.718-15.351h-15.575z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 723.655 635.097)",
    clipPath: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.349v-9.166H10.545v-18.519h14.457v-9.24H10.545v-18.483h16.804v-9.203H0Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 761.91 632.563)",
    clipPath: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.35v-9.166H10.545v-18.519h14.457v-9.24H10.545v-27.686H0z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 808.81 632.563)",
    clipPath: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.349v-9.166H10.545v-18.519h14.457v-9.24H10.545v-18.483h16.804v-9.203H0Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 854.716 632.563)",
    clipPath: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10.545l9.985-37.484V0h9.763v-64.611H19.748l-9.613 36.292v-36.292H0Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 901.615 632.563)",
    clipPath: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 9.042 5.043 13.563 15.128 13.563 10.109 0 15.165-4.521 15.165-13.563v-8.682H19.748V0c0 2.906-1.527 4.359-4.583 4.359h-.074c-3.03 0-4.546-1.453-4.546-4.359v-5.851c0-2.881 3.291-6.408 9.874-10.582 6.583-4.148 9.874-9.129 9.874-14.941v-8.16c0-9.068-5.043-13.601-15.128-13.601C5.054-53.109 0-48.577 0-39.534v8.681h10.545v-8.681c0-2.907 1.54-4.36 4.62-4.36 3.056 0 4.583 1.453 4.583 4.36v7.378c0 3.13-3.291 6.781-9.874 10.955C3.291-17.054 0-12.011 0-6.074Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 953.93 649.454)",
    clipPath: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.35v-9.166H10.545v-18.519h14.458v-9.24H10.545v-18.483H27.35v-9.203H0Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1006.244 632.563)",
    clipPath: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.484 473.076h12.111v-12.109h-12.111z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 0 1333.333)",
    clipPath: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-9.043-5.056-13.575-15.165-13.601-10.085 0-15.128 4.534-15.128 13.601v39.534c0 9.042 5.043 13.563 15.128 13.563C-5.056 53.097 0 48.576 0 39.534v-8.682h-10.545v8.682c0 2.906-1.527 4.36-4.583 4.36h-.074c-3.03 0-4.546-1.454-4.546-4.36V0c0-2.907 1.527-4.359 4.583-4.359 3.079 0 4.62 1.452 4.62 4.359v8.682H0Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1120.61 702.167)",
    clipPath: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 2.906-1.527 4.359-4.583 4.359h-.074c-3.031 0-4.546-1.453-4.546-4.359v-39.534c0-2.907 1.527-4.36 4.582-4.36 3.08 0 4.621 1.453 4.621 4.36zm10.545-39.534c0-9.043-5.056-13.575-15.166-13.601-10.084 0-15.127 4.533-15.127 13.601V0c0 9.042 5.043 13.563 15.127 13.563 10.11 0 15.166-4.521 15.166-13.563z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1157.375 649.454)",
    clipPath: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 12.259 44.266h10.545v-64.611H12.705v36.256L3.688-20.345h-7.153l-9.278 36.256v-36.256h-10.21v64.611h10.545z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1213.964 691.585)",
    clipPath: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-22.93 10.892-32.103 24.65c-9.172 13.759-1.719 16.243 6.879 15.288 8.599-.956 37.645-15.861 49.874-16.052 12.23-.191 92.104-1.529 92.104-1.529s-6.879-10.892-45.096-18.344c0 0 25.415.191 47.008 13.185 21.592 12.994 34.586 23.121 43.758 21.402 9.173-1.72 10.892-14.141-4.968-28.854-15.86-14.714-39.937-18.154-39.937-18.154l2.484 5.542s.765 3.439.573 4.586c-.191 1.146-2.484.764-2.484.764s3.057 1.911 4.013 3.631c0 0-3.631-2.102-6.306-.573 0 0 8.599 2.292 23.313 13.185 14.714 10.892 18.726 13.524 24.268 13.949 0 0-1.72 3.631-20.637-8.599C123.825 11.848 93.633-4.968 47.008.382c-46.626 5.35-73.76 31.147-77.2 31.53C-33.631 32.294-23.503 15.86 0 0",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 137.376 633.057)",
    clipPath: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-20.064 6.879-73.568 0-73.568 0s11.464-.382 13.376-2.293c0 0-7.835-.574-7.071-1.72C-66.499-5.16-33.872-7.031 0-5.16c0 0-3.057 1.338-4.395 2.293l-12.994.192S-2.102-1.338 0 0",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 275.128 592.292)",
    clipPath: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.157.157 0 0 0-.193-.009c-1.68 1.182-3.224 2.524-4.761 3.893-1.51 1.395-2.96 2.868-4.302 4.453-1.327 1.585-2.856 3.113-3.672 5.096-.817 1.956-1.373 4.115-1.072 6.318a.17.17 0 0 0 .19.145.17.17 0 0 0 .109-.063l.004-.004c1.362-1.713 2.428-3.286 3.514-4.904.563-.795 1.025-1.638 1.49-2.504.214-.442.439-.881.687-1.309.243-.431.484-.864.754-1.28a59.233 59.233 0 0 1 1.68-2.467 57.657 57.657 0 0 1 1.773-2.428C-2.604 3.317-1.312 1.76.013.225L.016.222A.158.158 0 0 0 0 0m-52.829 14.187c-.546-2.074-1.858-3.791-2.963-5.538-1.12-1.75-2.361-3.402-3.673-4.985-1.342-1.561-2.694-3.096-4.202-4.491a.156.156 0 0 0-.192-.016.158.158 0 0 0-.046.218l.003.003c1.109 1.697 2.182 3.412 3.153 5.176.504.868.978 1.754 1.434 2.642.475.879.912 1.773 1.338 2.668.213.448.394.909.577 1.369.189.457.354.922.507 1.389.346.92.692 1.816 1.144 2.68.862 1.747 1.71 3.448 2.832 5.326l.004.006a.164.164 0 0 0 .1.075.168.168 0 0 0 .207-.117c.591-2.144.326-4.358-.223-6.405M5.069-.848C3.35 6.987-4.485 17.688-10.026 23.039c-5.542 5.35-11.275 1.91-15.479-1.912-4.203-3.821-9.745-3.439-14.905.765-5.159 4.204-8.407 6.497-14.331 2.293-5.924-4.204-12.612-22.166-12.612-22.166-1.72-12.803-5.159-24.65-5.159-24.65s60.384 5.159 79.683-.765c0 0-.382 14.714-2.102 22.548",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 269.643 557.02)",
    clipPath: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.081.068-.161.133-.242.202 0 0 .081-.074.242-.202",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 117.485 687.086)",
    clipPath: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.858-.339-1.755-.544-2.642-.794-.445-.118-.901-.185-1.352-.281a17.891 17.891 0 0 0-1.36-.236 28.482 28.482 0 0 0-5.504-.261c-1.832.09-3.668.338-5.413.905a65.814 65.814 0 0 1 5.412.066c1.787.103 3.567.251 5.328.528C-3.767.172-2.013.507-.277.936c1.75.394 3.452.953 5.216 1.455C3.396 1.417 1.743.583 0 0m-2.895 2.581C-19.836-1.74-28.644 4.415-30.169 5.628-9.656-11.654 5.371-.07 17.743 5.83c12.42 5.924 25.414 3.821 25.414 3.821v4.204C27.297 21.499 15.832 7.358-2.895 2.581",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 157.71 694.59)",
    clipPath: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.081.068.161.133.242.202C.242.202.161.128 0 0",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 334.68 687.086)",
    clipPath: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.764-.502 3.466-1.061 5.216-1.455a51.354 51.354 0 0 1 5.255-1.009c1.761-.276 3.541-.425 5.328-.527a65.787 65.787 0 0 1 5.411-.067c-1.744-.567-3.581-.815-5.412-.905a28.41 28.41 0 0 0-5.505.262c-.456.058-.909.141-1.36.235-.45.096-.906.163-1.351.281-.887.25-1.785.456-2.643.794C3.196-1.808 1.543-.974 0 0m-38.218 11.465V7.261s12.994 2.102 25.415-3.822c12.372-5.9 27.399-17.484 47.912-.202C33.583 2.024 24.775-4.131 7.834.19c-18.726 4.778-30.191 18.918-46.052 11.275",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 287.867 691.402)",
    clipPath: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-5.327 7.189L0 14.379l5.327-7.19Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 225.572 672.74)",
    clipPath: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-5.327 7.189L0 14.379l5.327-7.19Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 225.572 704.779)",
    clipPath: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-3.324-2.16-6.02-4.825-6.02S-9.65-3.324-9.65 0c0 3.324 2.16 6.02 4.825 6.02S0 3.324 0 0",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 232.006 679.046)",
    clipPath: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.626-1.254-1.63-1.171-3.254-2.339c-2.176-1.548-4.318-3.142-6.473-4.717-2.137-1.599-4.275-3.199-6.351-4.873-2.085-1.665-4.134-3.374-6.013-5.291 1.565 2.192 3.477 4.115 5.407 5.985a116.238 116.238 0 0 0 6.054 5.33c2.062 1.724 4.197 3.353 6.322 4.994 1.07.809 2.149 1.606 3.233 2.396l1.62 1.189 1.541 1.215.777.599c.253.208.49.434.735.651l1.463 1.313c.479.448.919.937 1.381 1.403.454.473.924.932 1.346 1.438 1.783 1.937 3.334 4.075 4.862 6.234 2.924 4.406 5.446 9.121 7.394 14.118-1.21-5.241-3.405-10.243-6.166-14.904C7.789 7.704 4.305 3.401 0 0m-26.589-4.31C-39.583-1.157-48.42 11.885-48.42 11.885S-37.528-.297-21.764-.297c-.86-1.29-.86-2.007-1.719-1.72-.86.287-3.106-2.293-3.106-2.293m-34.443 35.638 1.719.765s15.672-16.818 38.051-18.632l-.502-2.149c-23.227-.691-39.268 20.016-39.268 20.016m8.196-42.222c-1.256 1.165-2.496 2.339-3.788 3.45l-1.931 1.673-1 .906c-.336.301-.624.635-.937.953-2.415 2.61-4.335 5.538-6.075 8.544-1.713 3.021-3.237 6.142-4.424 9.402 1.879-2.909 3.74-5.798 5.66-8.629.991-1.393 1.932-2.817 2.981-4.152.504-.685 1.039-1.336 1.559-2.003.555-.63 1.077-1.299 1.668-1.883.29-.297.557-.625.86-.902l.9-.845c.637-.578 1.315-1.145 1.936-1.753 1.251-1.214 2.489-2.433 3.636-3.737 2.321-2.578 4.491-5.288 6.38-8.198-2.488 2.41-4.939 4.819-7.425 7.174m67.618 44.993C3.316 4.003-15.745 1.71-15.745 1.71 9.336 19.194 13.206 35.818 13.206 35.818c-2.581 4.157-9.173 2.58-9.173 2.58l-.143-4.012C-6.715 21.773-19.9 19.624-19.9 19.624c9.171-1.576 17.484 4.873 17.484 4.873-2.293-4.014-10.462-10.319-24.937-6.307-14.475 4.014-30.956 14.906-31.529 15.335-.574.43-2.15.717-2.15.717l-.143 1.863c4.786.015 4.586 4.013 4.586 4.013s-6.736-2.293-8.456-3.439c-1.72-1.147-3.87-.717 3.87-18.489C-53.437.42-34.328-9.756-34.328-9.756c-23.312 5.59-36.663 40.415-36.663 40.415l-5.376-6.019c.86-16.195 8.456-29.379 12.755-33.393 4.299-4.013 9.602-7.452 19.778-16.051 10.175-8.598 12.42-12.898 12.42-12.898-4.633 5.303-20.016 14.045-20.016 14.045 7.882-11.322 23.217-25.08 23.217-25.08C-8.722-33.116-3.706-14.198-3.706-14.198c-4.873-1.004-16.768-15.908-16.768-15.908C-12.305-15.918 1.023-6.46 1.023-6.46v-3.439C18.508-.727 23.524 30.803 23.524 30.803z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 261.31 746.55)",
    clipPath: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.069-9.275-12.431-16.025-23.507-16.025-11.075 0-20.444 6.75-23.513 16.025z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 162.636 762.33)",
    clipPath: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-56.982h-1.25v53.864l-19.788-49.514-1.162.469L-1.956-1.512l.712 1.769.619-.132z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 132.127 693.612)",
    clipPath: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.15-.487-20.513 48.795-.494 1.169-.712 1.7.581.243.625-.125.119-.024.881-2.101z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 161.011 762.005)",
    clipPath: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.069-9.275 12.432-16.025 23.507-16.025 11.075 0 20.444 6.75 23.513 16.025z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 289.17 762.33)",
    clipPath: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-56.982h1.25v53.864l19.788-49.514 1.162.469L1.956-1.512 1.244.257.625.125Z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 319.68 693.612)",
    clipPath: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 1.15-.487 20.513 48.795.494 1.169.712 1.7-.581.243-.625-.125-.119-.024-.881-2.101z",
    style: {
      fill: "#252C40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 290.795 762.005)",
    clipPath: "url(#H)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogoBlue);
export default __webpack_public_path__ + "static/media/ShortLogoBlue.1aa9f2fa2b2f4d67db70b2bee7195660.svg";
export { ForwardRef as ReactComponent };